import greaterThan from './greater-than';

export default function greaterThanOrEqualTo(value, options = {}) {
  return greaterThan(value, { ...options, equal: true });
}

greaterThanOrEqualTo.message = function message(value, options = {}) {
  return greaterThan.message(value, { ...options, equal: true });
};
